





























import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import api from '../../../api/v2/api';
import { userState } from '../../../client/stores/user';
import { EMBED_ROUTER_NAME } from '../../../embed/router';
import {headerState} from "../../../client/stores/header";
const EMBED_KEY = 'edbase-embed-token'

@Component({
  components: {
  }
})
export default class Home extends Vue {
  targetId: string | null = null
  embedToken = this.getEmbedToken()
  exam = null
  async mounted() {
    this.targetId = this.$route.params.targetId
    if (this.targetId) {
      if (window.location.href.includes('embed/exam')) {  
        try {
          this.exam = await api.exam.showForTest(this.targetId, {})
        } catch (error: any) {
          if (error.messages === 'Need to join exam') {
            this.getToken()
          }
        }
      }

      if (this.embedToken === null) {
        this.getToken()
      }
      this.getUser()
    }
  }

  async getToken(){
    this.embedToken = await api.embed.create({
      targetId: this.targetId,
      type: "EXAM",
      embedToken: this.embedToken ?? undefined
    });
    
    // Set Embed Token into storage
    this.setEmbedToken(this.embedToken);
    
    // Set embedTokenin global
    (window as any).embedToken = this.embedToken
  }

  async getUser(){
    await userState.getUser()
    this.$router.push({
      name: EMBED_ROUTER_NAME.EXAM_SHOW,
      params: {
        examId: this.targetId ?? ''
      }
    })

    headerState.getSchoolSetting()
  }

  getEmbedToken(){
    try {
      return localStorage.getItem(EMBED_KEY)
    } catch (error) {
      console.error("localStorage access deny");
      console.error(error);
      return null
    }
  }

  setEmbedToken(embedToken: string){
    try {
      localStorage.setItem(EMBED_KEY, embedToken);
    } catch (error) {
      console.error("localStorage access deny");
      console.error(error);
    }
  }
}
